import { CHARTER_THEME } from "../controleTheme";
import { blockingPatientHeaderRowStyle, blockingPatientIssueStyle, blockingPatientRowsStyle, blockingPatientSummaryStyle } from "../styles/patientStyles";

export function BlockingPatientIssuesForPoint({ issues, launchStatusLabels, onCommentChange, onLaunchStatusChange, disabled = false }) {
    const { inputStyle, launchStatusSelectStyle } = CHARTER_THEME;
    if (!issues.length) return null;
    const hasLaunchStatus = issues.some(issue => issue.pointKey === "tracageLogiciels");
    return (
        <section style={blockingPatientSummaryStyle}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                <h2 style={{ margin: 0, color: "#0f172a", fontSize: "14px", fontWeight: 950 }}>Patients à reprendre pour ce point</h2>
                <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    height: "26px",
                    padding: "0 10px",
                    borderRadius: "999px",
                    background: "#fee2e2",
                    color: "#991b1b",
                    fontSize: "12px",
                    fontWeight: 900,
                }}>
                    {issues.length} patient{issues.length > 1 ? "s" : ""}
                </span>
            </div>
            <div style={blockingPatientRowsStyle}>
                <div style={blockingPatientHeaderRowStyle(hasLaunchStatus)}>
                    <span>Nom prénom</span>
                    <span>Commentaire</span>
                    {hasLaunchStatus && <span>Statut</span>}
                </div>
                {issues.map(issue => (
                    <div key={`${issue.patientId}-${issue.pointKey}`} style={blockingPatientIssueStyle(hasLaunchStatus)}>
                        <div style={{ minWidth: 0, color: "#0f172a", fontSize: "13px", fontWeight: 850 }}>
                            <span>{issue.patientName}</span>
                            {issue.room && <span style={{ color: "#64748b", fontWeight: 750 }}> · Chambre {issue.room}</span>}
                        </div>
                        <textarea
                            value={issue.comment || ""}
                            disabled={disabled}
                            onChange={event => onCommentChange?.(issue.patientId, issue.pointKey, event.target.value)}
                            placeholder="Commentaire"
                            style={{
                                ...inputStyle,
                                width: "100%",
                                minHeight: "40px",
                                resize: "vertical",
                                lineHeight: 1.35,
                                background: disabled ? "#f1f5f9" : "white",
                                cursor: disabled ? "not-allowed" : "text",
                            }}
                        />
                        {hasLaunchStatus && (
                            issue.pointKey === "tracageLogiciels" ? (
                                <select
                                    value={issue.launchStatus || "PAS_LANCE"}
                                    disabled={disabled}
                                    onChange={event => onLaunchStatusChange?.(issue.patientId, issue.pointKey, event.target.value)}
                                    style={launchStatusSelectStyle(issue.launchStatus || "PAS_LANCE", disabled)}
                                >
                                    <option value="PAS_LANCE">{launchStatusLabels.PAS_LANCE}</option>
                                    <option value="LANCE">{launchStatusLabels.LANCE}</option>
                                </select>
                            ) : <span />
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}
